exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#asseco-chat-plugin,#asseco-chat .asseco-floaty-btn{background-color:#f57c00}", ""]);

// exports
